import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { api } from '../../../config';

function ProtectedRoute({ children }) {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const verifyAuth = async () => {
      const isLoggedIn = localStorage.getItem("isLoggedIn");

      if (!isLoggedIn) {
        setIsAuthenticated(false);
        setIsChecking(false);
        return;
      }

      try {
        // Verify with backend that session is still valid
        const response = await api.get('/me');
        if (response.data && (response.data.user || response.data._id)) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
          localStorage.removeItem("isLoggedIn");
          localStorage.removeItem("adminInfo");
        }
      } catch (error) {
        console.log('Auth verification failed:', error);
        // If backend check fails, fall back to localStorage check
        // This allows offline-like behavior but with security
        setIsAuthenticated(!!isLoggedIn);
      } finally {
        setIsChecking(false);
      }
    };

    verifyAuth();
  }, []);

  if (isChecking) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-dark">
        <div className="text-center">
          <div className="spinner-border text-warning" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-white mt-3">Verifying authentication...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin_login" replace />;
  }

  return children;
}

export default ProtectedRoute;
